import React from "react";
import { startBulkInvitationsThunk, validateDelegeesThunk, getBulkImportProgressThunk } from "../../store/actions/entryRights.actions";
import { StartBulkInvitationsRequestModel } from "../../models/bulkImport/StartBulkInvitationsRequestModel";
import MultipleDelegeesForm from "../MultipleDelegeesForm/MultipleDelegeesForm";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { ValidateDelegeesRequestModel } from "../../models/bulkImport/ValidateDelegeesRequestModel";
import { ValidateDelegeesResponseModel } from "../../models/bulkImport/ValidateDelegeesResponseModel";
import { AxiosResponse } from "axios";
import {
    getDelegeesValidationResult as getDelegeesValidationResultApi,
    getDelegeesInvitationResult as getDelegeesInvitationResultApi
} from "../../api/entryRights.api";

interface EntryRightMultipleDelegeesFormProps {
    onClose: () => void;
    translationContextName: string;
}

const EntryRightMultipleDelegeesForm: React.FC<EntryRightMultipleDelegeesFormProps> = ({
    onClose,
    translationContextName
}) => {
    const dispatch = useAppDispatch();

    // Select state from Redux store
    const validateDelegeesProgress = useAppSelector((state: RootState) => state.entryRights.validateDelegees);
    const hasErrors = useAppSelector((state: RootState) => state.entryRights.error != null);
    const bulkImportProgress = useAppSelector((state: RootState) => state.entryRights.bulkImportProgress);

    // Define dispatch functions
    const startBulkInvitations = (
        seasonTicketOwnerCrmId: string,
        fileReference: string,
        request: StartBulkInvitationsRequestModel,
        onSuccess: VoidFunction
    ) => {
        dispatch(
            startBulkInvitationsThunk({
                seasonTicketOwnerCrmId,
                fileReference,
                request,
                onSuccess
            })
        );
    };

    const validateDelegees = (
        seasonTicketOwnerCrmId: string,
        req: ValidateDelegeesRequestModel,
        onSuccess: (response: ValidateDelegeesResponseModel) => void,
        onError: (errorCode: string) => void) => {
        dispatch(validateDelegeesThunk({
            seasonTicketOwnerCrmId,
            request: req,
            onSuccess,
            onError
        }));
    };

    const getBulkImportProgress = (
        seasonTicketOwnerCrmId: string,
        fileReference: string,
        pollBulkImportProgress: () => void
    ) => {
        dispatch(
            getBulkImportProgressThunk({
                seasonTicketOwnerCrmId,
                fileReference,
                pollBulkImportProgress
            })
        );
    };

    const getDelegeesValidationResult = (
        seasonTicketOwnerCrmId: string,
        fileReference: string,
        language: string): Promise<AxiosResponse<Blob>> => {
        return getDelegeesValidationResultApi(seasonTicketOwnerCrmId, fileReference, language);
    };

    const getDelegeesInvitationResult = (
        seasonTicketOwnerCrmId: string,
        fileReference: string,
        language: string): Promise<AxiosResponse<Blob>> => {
        return getDelegeesInvitationResultApi(seasonTicketOwnerCrmId, fileReference, language);
    };

    return (
        <MultipleDelegeesForm
            onClose={onClose}
            startBulkInvitations={startBulkInvitations}
            validateDelegeesProgress={validateDelegeesProgress}
            getBulkImportProgress={getBulkImportProgress}
            validateDelegees={validateDelegees}
            getDelegeesValidationResult={getDelegeesValidationResult}
            getDelegeesInvitationResult={getDelegeesInvitationResult}
            hasErrors={hasErrors}
            bulkImportProgress={bulkImportProgress}
            translationContextName={translationContextName}
        />
    );
};

export default EntryRightMultipleDelegeesForm;
